import React from 'react';
import PointApprovalManagement from './PointApprovalManagement';

const PointApprovalManagementDaily: React.FC = () => {
  return <PointApprovalManagement period="daily" />;
};

export default PointApprovalManagementDaily; 